// KS2 Workbook — Junior Programme (Ages 7–11)
// Companion to the KS2 Student Book. Each chapter offers 5 short worksheet-style
// activities children can complete in pencil — designed for quick teacher print or
// home-learning. Activity types: WRITE, DRAW, MATCH, CIRCLE, TICK.

export const META = {
  series: "Ambedkarite Buddhist Educational Series — UK Edition",
  title: "Junior Programme · Workbook",
  subtitle: "Ages 7–11 · 12 chapters of pencil-friendly activities",
  edition: "Phase 1 · Workbook · 2026",
};

// Each task = { type: "WRITE"|"DRAW"|"MATCH"|"CIRCLE"|"TICK", prompt, lines?, items?, answer? }
export const WORKSHEETS = [
  {
    n: 1, title: "What is Dignity?",
    intro: "Read Chapter 1 of the Student Book first. Then complete these tasks.",
    tasks: [
      { type: "WRITE", prompt: "In your own words, what does dignity mean?", lines: 3 },
      { type: "WRITE", prompt: "Why was young Bhimrao refused water at school?", lines: 2 },
      { type: "CIRCLE", prompt: "Circle the words that mean the same as 'dignity'.",
        items: ["respect", "lazy", "value", "rude", "worth"] },
      { type: "DRAW", prompt: "Draw a small Dignity Shield with one word inside it that you stand for. (Examples: kindness, honesty, courage.)" },
      { type: "WRITE", prompt: "Finish this sentence: 'Everyone in our class deserves dignity because…'", lines: 2 },
    ],
  },
  {
    n: 2, title: "The Prince Who Sought Truth",
    intro: "Read Chapter 2 of the Student Book first.",
    tasks: [
      { type: "WRITE", prompt: "What was the prince's name before he became the Buddha?", lines: 1 },
      { type: "TICK", prompt: "Tick the four sights Siddhartha saw outside the palace.",
        items: ["an old person", "a king's crown", "a sick person", "a dead body", "a holy seeker", "a tiger"] },
      { type: "WRITE", prompt: "Why do you think Siddhartha left his rich palace?", lines: 3 },
      { type: "DRAW", prompt: "Draw the bodhi tree. Show a peaceful person sitting under it." },
      { type: "WRITE", prompt: "What is one question YOU would like to find the truth about?", lines: 2 },
    ],
  },
  {
    n: 3, title: "Compassion (Karuṇā) — When Hearts Help",
    intro: "Read Chapter 3 of the Student Book first.",
    tasks: [
      { type: "WRITE", prompt: "What does the word karuṇā mean in Pāli?", lines: 1 },
      { type: "MATCH", prompt: "Match each situation with a kind action.",
        items: [
          ["A child sitting alone at lunch.", "Invite them to your table."],
          ["A friend has dropped their books.", "Help them pick everything up."],
          ["Someone is upset in the playground.", "Listen and ask if they're OK."],
        ] },
      { type: "TICK", prompt: "Tick the things that show karuṇā in action.",
        items: ["sharing your snack", "laughing at someone's mistake", "comforting a crying child", "ignoring a hurt friend", "helping a younger pupil read"] },
      { type: "WRITE", prompt: "Write about a time someone showed you compassion. How did it feel?", lines: 4 },
      { type: "DRAW", prompt: "Draw two hands — one offering help, one receiving it." },
    ],
  },
  {
    n: 4, title: "Mindfulness — A Quiet Mind",
    intro: "Read Chapter 4 of the Student Book first.",
    tasks: [
      { type: "WRITE", prompt: "What does 'mindful' mean?", lines: 2 },
      { type: "TICK", prompt: "Tick the moments when being mindful would help.",
        items: ["Before a spelling test", "When you're angry", "When eating a snack", "While crossing the road", "All of the above"] },
      { type: "WRITE", prompt: "Try the breathing exercise: breathe in for 4, hold for 4, out for 6. Repeat three times. Then write — what did your mind notice?", lines: 4 },
      { type: "DRAW", prompt: "Draw your mind as weather. Is it sunny? Stormy? Cloudy? Mixed? Label the parts." },
      { type: "WRITE", prompt: "Name one place at school where you can find a quiet mind.", lines: 1 },
    ],
  },
  {
    n: 5, title: "The First School for Girls",
    intro: "Read Chapter 5 of the Student Book first.",
    tasks: [
      { type: "WRITE", prompt: "Who were Savitribai and Jyotirao Phule?", lines: 2 },
      { type: "WRITE", prompt: "What did Savitribai do that was very brave for her time?", lines: 3 },
      { type: "TICK", prompt: "Tick the things that ALL children in Britain today have a right to.",
        items: ["Free education", "A safe school environment", "Their own opinions", "Pocket money", "To be heard"] },
      { type: "WRITE", prompt: "If a school could be named after a teacher you admire, who would you choose? Why?", lines: 3 },
      { type: "DRAW", prompt: "Draw a school of the future. Who is welcome there?" },
    ],
  },
  {
    n: 6, title: "The Power of \"Why?\"",
    intro: "Read Chapter 6 of the Student Book first.",
    tasks: [
      { type: "WRITE", prompt: "Babasaheb said: 'Educate, Agitate, Organise.' What does each word mean to you?", lines: 4 },
      { type: "WRITE", prompt: "Why is asking 'Why?' so important?", lines: 2 },
      { type: "CIRCLE", prompt: "Circle the questions a curious mind might ask.",
        items: ["Why is the sky blue?", "When is lunch?", "Why is anyone treated unfairly?", "How do birds fly?", "Why doesn't everyone learn to read?"] },
      { type: "WRITE", prompt: "Write three 'Why?' questions about your own school.", lines: 3 },
      { type: "DRAW", prompt: "Draw your Big Question — the one you most want to find an answer to." },
    ],
  },
  {
    n: 7, title: "A Constitution for Equals",
    intro: "Read Chapter 7 of the Student Book first.",
    tasks: [
      { type: "WRITE", prompt: "What is a constitution?", lines: 2 },
      { type: "WRITE", prompt: "Babasaheb led the writing of India's Constitution. Why was this so important?", lines: 3 },
      { type: "WRITE", prompt: "Write three rules you would put in a 'Class Constitution' for your classroom.", lines: 3 },
      { type: "TICK", prompt: "Tick the rules that protect everyone equally.",
        items: ["Boys go first.", "We all listen when someone speaks.", "The tallest are line leaders.", "Everyone gets a turn.", "Only quiet people get marbles."] },
      { type: "DRAW", prompt: "Design the front cover of YOUR class constitution." },
    ],
  },
  {
    n: 8, title: "The Eightfold Path",
    intro: "Read Chapter 8 of the Student Book first.",
    tasks: [
      { type: "WRITE", prompt: "Name the Eightfold Path in your own words. (Hint: each step is a 'Right…')", lines: 8 },
      { type: "MATCH", prompt: "Match the path step to a school example.",
        items: [
          ["Right Speech", "Telling the truth, even when hard."],
          ["Right Action", "Helping a younger child read."],
          ["Right Effort", "Trying again after a wrong answer."],
        ] },
      { type: "WRITE", prompt: "Pick one step. Describe how you could practise it this week.", lines: 3 },
      { type: "DRAW", prompt: "Draw a path with eight stepping stones. Label each one." },
      { type: "WRITE", prompt: "Which step do you find HARDEST? Why?", lines: 2 },
    ],
  },
  {
    n: 9, title: "The Monkey King's Bridge",
    intro: "Read Chapter 9 of the Student Book first.",
    tasks: [
      { type: "WRITE", prompt: "What did the Monkey King do to save his troop?", lines: 3 },
      { type: "WRITE", prompt: "What does 'sacrifice' mean? Use it in a sentence.", lines: 2 },
      { type: "TICK", prompt: "Tick the actions that show care for others.",
        items: ["Holding the door for someone.", "Pushing in line.", "Sharing the last biscuit.", "Listening to a friend who is sad.", "Laughing at someone tripping."] },
      { type: "WRITE", prompt: "Write about a time you put someone else first.", lines: 3 },
      { type: "DRAW", prompt: "Draw the Monkey King's bridge. Who is crossing it?" },
    ],
  },
  {
    n: 10, title: "Many Faiths, One Britain",
    intro: "Read Chapter 10 of the Student Book first.",
    tasks: [
      { type: "WRITE", prompt: "Name three faiths or traditions in Britain today.", lines: 3 },
      { type: "WRITE", prompt: "What does 'tolerance' mean?", lines: 2 },
      { type: "TICK", prompt: "Tick the ways our school welcomes different faiths.",
        items: ["Celebrating festivals from many cultures", "Quiet/prayer space available", "Shared values like respect & kindness", "All of the above"] },
      { type: "WRITE", prompt: "Pick a festival not from your own family. Write 3 facts about it.", lines: 4 },
      { type: "DRAW", prompt: "Draw a 'tree of friends' — different leaves, all the same tree." },
    ],
  },
  {
    n: 11, title: "The Kind Emperor",
    intro: "Read Chapter 11 of the Student Book first.",
    tasks: [
      { type: "WRITE", prompt: "Who was Emperor Ashoka, and what did he change about himself?", lines: 4 },
      { type: "WRITE", prompt: "What are 'rock edicts' and why did Ashoka build them?", lines: 3 },
      { type: "TICK", prompt: "Tick the qualities a 'kind leader' has.",
        items: ["Listens to others", "Shouts for attention", "Forgives mistakes", "Picks favourites", "Cares for the weakest"] },
      { type: "WRITE", prompt: "If you were Class Leader for a day, write three kind decisions you would make.", lines: 3 },
      { type: "DRAW", prompt: "Design YOUR own 'Edict of Kindness' poster for the classroom." },
    ],
  },
  {
    n: 12, title: "We Are the Next Story",
    intro: "Read Chapter 12 of the Student Book — the final chapter.",
    tasks: [
      { type: "WRITE", prompt: "Looking back at the whole book — which chapter changed your thinking most? Why?", lines: 4 },
      { type: "WRITE", prompt: "Name 3 things YOU can do in school that show dignity, compassion and equality.", lines: 4 },
      { type: "DRAW", prompt: "Draw a picture of yourself five years from now. What kind of person are you becoming?" },
      { type: "WRITE", prompt: "Write a short letter to a younger pupil about what THIS book taught you.", lines: 6 },
      { type: "WRITE", prompt: "Finish this sentence: 'The next story belongs to me, and I will write it by…'", lines: 3 },
    ],
  },
];
